import { Injectable } from '@angular/core';
import { Observable } from "rxjs"
import { map } from 'rxjs/operators';
import { AngularFirestore, validateEventsArray } from '@angular/fire/firestore';
import { Sesiones } from './modulo';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(private db: AngularFirestore) { }

  cursos: Observable<any>;
  instructores: Observable<any>;
  empresas: Observable<any>;

  //////////////////////CRUD SIMPLE //////////////////////////////////

  ////////////////////// CURSOS ////////////////////////

  getCursos() {
    this.cursos = this.db.collection('cursos').valueChanges();
    return this.cursos
  }

  createCurso(nombre: any, curso: any) {
    return this.db.collection("cursos").doc(nombre).set(curso);
  }

  updateCurso(id: any, curso: any) {
    return this.db.collection("cursos").doc(id).update(curso);
  }

  deleteCurso(id: any) {
    return this.db.collection("cursos").doc(id).delete();
  }

  getCursoInfo(id: any) {
    return this.db.collection('cursos').doc(id).ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }

  ////////////////////// INSTRUCTORES ////////////////////////

  getInstructores() {
    this.instructores = this.db.collection('instructores').get();
    return this.instructores
  }

  createInstructor(nombre: any, instructor:any){
    return this.db.collection("instructores").doc(nombre).set(instructor);
  }

  updateInstructor(id:any,instructor:any){
    return this.db.collection("instructores").doc(id).update(instructor);
  }

  deleteInstructor(id:any){
    return this.db.collection("instructores").doc(id).delete();
  }

  getInstructorInfo(id: any) {
    return this.db.collection('instructores').doc(id).ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }

  ////////////////////// EMPRESAS ////////////////////////////

  getEmpresas() {
    this.empresas = this.db.collection('empresas').get();
    return this.empresas
  }

  createEmpresa(nombre: any,empresa: any) {
    return this.db.collection("empresas").doc(nombre).set(empresa);
  }

  updateEmpresa(id:any,empresa:any){
    return this.db.collection("empresas").doc(id).update(empresa);
  }

  deleteEmpresa(id:any){
    return this.db.collection("empresas").doc(id).delete();
  }

  getEmpresaInfo(id: any) {
    return this.db.collection('empresas').doc(id).ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }

  //////////////////////// Relaciones entre elementos ///////////////////////////

  getInstructoresEmpresa(id: any) {
    var query = this.db.collection('instructores').ref
      .where('empresa.id', '==', id)
    this.instructores = this.db.collection('instructores', ref => query).get();
    return this.instructores;
  }

  getCursosInstructor(id: any) {
    var query = this.db.collection('cursos').ref
      .where('instructor.id', '==', id)
    this.cursos = this.db.collection('cursos', ref => query).get();
    return this.cursos;
  }

  getCursosEmpresa(id: any) {
    var query = this.db.collection('cursos').ref
      .where('instructor.idEmpresa', '==', id)
    this.cursos = this.db.collection('cursos', ref => query).get();
    return this.cursos;
  }

  //////////////////////// Querys Especificos /////////////////////////////////

  getCursosDestacados(limit: number) {
    var query = this.db.collection('cursos').ref
    .orderBy('compras')
    .limit(limit)
    this.cursos = this.db.collection('cursos', ref => query).valueChanges();
    return this.cursos
  }

  getCursosRelacionados(categoria: any, limit: number) {
    var query = this.db.collection('cursos').ref
      // .orderBy('compras')
      .where('categoria', '==', categoria)
      .limit(limit);
    this.cursos = this.db.collection('cursos', ref => query).get();
    return this.cursos;
  } 

  /// Paginación //////

  primero(collection,paginacion){
    var query = this.db.collection(collection).ref
    .limit(paginacion)
    .orderBy('nombre')
    this.cursos = this.db.collection(collection,ref => query).get()
    return this.cursos
  }
  
  next(collection,last,paginacion){
    var query = this.db.collection(collection).ref
    .limit(paginacion)
    .orderBy('nombre')
    .startAfter(last.nombre)
    this.cursos = this.db.collection(collection,ref => query).get()
    return this.cursos
  }

  // Sesiones

  getSesiones() {
    this.cursos = this.db.collection('sesiones').get();
    return this.cursos
  }

  createSesion(cursoId: any,contenido: any) {
    return this.db.collection("sesiones").doc(cursoId).set(contenido);
  }

  updateSesion(id:any,contenido:any){
    return this.db.collection("sesiones").doc(id).set(contenido, {merge: true});
  }

  getSesion(id: any) {
    return this.db.collection('sesiones').doc(id).ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }

  deleteSesion(id:any){
    return this.db.collection("sesiones").doc(id).delete();
  }

  

  // Progresos

  getUsuarioProgreso(id: any) {
    var query = this.db.collection('progresos').ref
      .where('idUsuario', '==', id)
    this.cursos = this.db.collection('progresos', ref => query).get();
    return this.cursos;  
  }

  createProgreso(usuariocurso:any, progreso:any) {
    return this.db.collection("progresos").doc(usuariocurso).set(progreso);
  }

  updateProgreso(id:any, progreso:any) {
    return this.db.collection("progresos").doc(id).update(progreso);
  }

  getProgreso(id: any) {
    return this.db.collection('progresos').doc(id).ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }

  deleteProgreso(id:any){
    return this.db.collection("progresos").doc(id).delete();
  }

  //////////////////////////// Global /////////////////////////////////////////

  getGlobal() {
    return this.db.collection('global').doc('global').ref.get().then(function (doc) {
      return doc.data()
    }).catch(error => {
      console.log("error obteniendo el documento: ", error);
    })
  }
  
}
